/**
 * Constants for the Node enviroments in the application
 */
export const NODE_ENVS = {
  dev: "development",
  test: "test",
};

/**
 * Gip auth error codes
 */
export const AUTH_GIP_ERROR_CODES = {
  userNotFound: "auth/user-not-found",
  wrongPassword: "auth/wrong-password",
};

/**
 * Table sorting orders
 */
export const SORTING_ORDERS = {
  desc: "desc",
  asc: "asc",
};

/**
 * Common api response codes
 */
export const RESPONSE_CODES = {
  success: 200,
  badRequest: 400,
  unAuthorised: 401,
  notFound: 404,
  internalServerError: 500,
};

/**
 * Table per page options
 */
export const TABLE_PER_PAGES_OPTIONS = [5, 10, 25, 50, 100];

/**
 *  Roles list
 */
export const ROLES = {
  admin: "admin",
  user: "user",
  owner: "owner",
};

/*
 * Month names constants
 */
export const MONTHS = Object.freeze({
  month_names: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  month_names_short: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
});

/**
 * Status chip colours
 */
export const STATUS_CHIP_COLORS = {
  active: "#41CE65",
  disabled: "#1E2533",
  bounced: "#F53B57",
};

/**
 * Csv file label to be ingnored
 */
export const IGNORE_CSV_LABEL = "actions";

/**
 * Selected records tooltip
 */
export const TOOLTIP_SEPERATOR = "\n";

/**
 * Debounce method delay millis
 */
export const DEBOUNCE_MILLIS = 500;

/**
 * Customer status options
 */
export const CUSTOMER_STATUS_OPTIONS = [
  { text: "Active", value: "active" },
  { text: "Hold", value: "hold" },
  { text: "Suspended", value: "suspended" },
  { text: "Cancelled", value: "cancelled" },
];

/**
 * Account status options
 */
export const ACCOUNT_STATUS_OPTIONS = [
  { text: "Active", value: "active" },
  { text: "Inactive", value: "inactive" },
];

/**
 * SEED_STATUSES
 * List of supported statuses of a seed addresss
 */
export const SEED_STATUSES = {
  active: "active",
  archived: "archived",
};

/**
 * Display breakpoints
 */
export const DISPLAY_BREAKPOINTS = {
  xs: "xs",
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
};
/**
 * Underscore character to be replcaed in server error messages
 */
export const UNDER_SCORE = "_";

/**
 * Mailbox provider access types
 */
export const ACCESS_TYPES = Object.freeze([
  { name: "IMAP", value: 0 },
  { name: "Gmail API", value: 1 },
]);

/**
 * Promises statuses whether a promise have been fullfilled or rejected
 */
export const PROMISE_STATUSES = Object.freeze({
  fulfilled: "fulfilled",
  rejected: "rejected",
});
